import PubSub from 'pubsub-js';
import { EventBusProps, EventKeys } from '../events';

class PubSubEventBus implements EventBusProps {
  private instance: typeof PubSub;

  constructor(instance = PubSub) {
    this.instance = instance;
  }

  public publish <T>(key: EventKeys, value: T): boolean {
    return this.instance.publish(key, value);
  }

  public subscribe <T>(
    key: EventKeys,
    listener: (message: EventKeys, data?: T) => void,
  ): string {
    return this.instance
      .subscribe(key, listener as (message: string, data?: T) => void);
  }

  public unsubscribe <T>(
    listenerOrToken: string | ((message: EventKeys, data?: T) => void),
  ): string | boolean {
    return this.instance
      .unsubscribe(listenerOrToken as (message: string, data?: T) => void);
  }

  public getSubscriptions(token: EventKeys): (string | symbol)[] {
    return this.instance.getSubscriptions(token);
  }

  public countSubscriptions(token: EventKeys): number {
    return this.instance.countSubscriptions(token);
  }

  public clearAllSubscriptions(token: EventKeys | undefined): void {
    return this.instance.clearAllSubscriptions(token);
  }
}

export { PubSubEventBus };
